import { useState } from 'react'
import styled from 'styled-components/macro'

import { Button, EmptyState, Layout, Text } from '@loadsmart/loadsmart-ui'
import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

import IconLoadsmart from 'core/ui/assets/icon-loadsmart.svg'
import IllustrationDepartingTruck from 'core/ui/assets/illustration-departing-truck.svg'

import { SignUpDialog } from 'auth/ui/SignUpDialog'

const Wrapper = styled(Layout.Stack)`
  width: 100%;
  height: 100%;
  padding: ${getToken('space-3xl')};
`

export function ErrorState() {
  const [dialogOpen, setDialogOpen] = useState(false)

  function handleSignUp() {
    setDialogOpen(true)
  }

  function handleCancelSignUp() {
    setDialogOpen(false)
  }

  function handleCompleteSignUp() {
    setDialogOpen(false)
  }

  return (
    <Wrapper align="center" justify="center">
      <EmptyState
        variant="page"
        illustration={IllustrationDepartingTruck}
        title="Oops! Nothing here."
        description="Looks like the page you're looking for does not exist or is not available anymore."
      />
      <Text variant="body-bold">
        Go to our carrier platform and find spot loads to keep your truck full
      </Text>
      <Button
        type="button"
        variant="primary"
        leading={<img src={IconLoadsmart} alt="" />}
        onClick={handleSignUp}
      >
        Sign up to start booking
      </Button>
      {dialogOpen && (
        <SignUpDialog
          onCancel={handleCancelSignUp}
          onComplete={handleCompleteSignUp}
          context="error-state"
        />
      )}
    </Wrapper>
  )
}
